module.exports = __webpack_public_path__ + "static/media/mana.dc098a3c.svg";